import { orderBy } from "lodash";

import {
  PremadeCharacter,
  PremadeInfoStatus,
} from "@dndbeyond/character-rules-engine";

import { getPrimarySource } from "./getPrimarySource";

/**
 * Orders premades by primary source display order, source name, and then
 * character name. Unsourced characters sort last. With `prioritizeDrafts`,
 * drafts surface above archived premades.
 */
export const orderPremades = (
  premades: Array<PremadeCharacter>,
  prioritizeDrafts = false
): Array<PremadeCharacter> => {
  return orderBy(premades, [
    ...(prioritizeDrafts
      ? [
          (char: PremadeCharacter) =>
            char.publishStatus === PremadeInfoStatus.DRAFT ? 0 : 1,
        ]
      : []),
    (char) => getPrimarySource(char).displayOrder,
    (char) => getPrimarySource(char).sourceName,
    (char) => char.characterData.name,
  ]);
};
